import * as React from 'react';

export const azFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3136)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#AF0100'
            />
            <mask
                id='mask0_55_3136'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3136)'>
                <path
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#73BE4A'
                />
                <path
                    d='M0 0H28V6.66667H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#3CA5D9'
                />
                <path
                    d='M14.6094 6C15.8012 5.99712 17.2544 6.61051 17.6719 7.48535C17.6719 7.48535 16.1014 6.8731 14.5869 7.19531C13.0724 7.51757 12.197 8.65289 12.1836 10.0547C12.1695 11.552 13.3789 12.6695 14.7559 12.9688C16.122 13.2656 17.5844 12.4513 17.6074 12.4385C17.4298 12.9031 16.5747 13.9955 14.7744 14C12.5283 14.0056 9.97587 12.5679 10 10.04C10.0235 7.60203 12.3908 6.00548 14.6094 6ZM17.3359 9.24023L18.7998 9.26855L17.6328 10.1025L18.0566 11.4238L16.8555 10.6348L15.6533 11.4238L16.0771 10.1025L14.9102 9.26855L16.374 9.24023L16.8555 7.93652L17.3359 9.24023Z'
                    fill='#F7FCFF'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3136'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
